/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAndroidPill: {
  name: 'android-pill';
  data: string;
} = {
  name: 'android-pill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.293 2.293a1 1 0 0 1 1.414 0l2 2c.023.022.044.046.064.07C10.47 4.127 11.22 4 12 4c.78 0 1.53.127 2.23.363.02-.024.04-.048.063-.07l2-2a1 1 0 1 1 1.414 1.414l-1.614 1.614A6.99 6.99 0 0 1 19 11v4a7 7 0 1 1-14 0v-4a6.99 6.99 0 0 1 2.907-5.68L6.293 3.708a1 1 0 0 1 0-1.414ZM7 11a5 5 0 0 1 10 0v4H7v-4Zm.416 6a5.001 5.001 0 0 0 9.168 0H7.416ZM11 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
